import './App.css';
import About from './pages/About';
import Home from './pages/Home';
import Project from './pages/Project';
import Skills from './pages/Skills';
import Footer from './components/Footer';
import Contact from './pages/Contact';
import { ToastContainer } from 'react-toastify';
import Certificate from './pages/Certificate';
import Work from './pages/Work';
import {BsFillArrowUpCircleFill} from "react-icons/bs"
import Blog from './pages/Blog';

function App() {
  return (
    <div className='app' >
      <Home></Home>
      <br></br>
      <About></About>
      {/* <br></br>
      <br></br> */}
      {/* <Blog></Blog> */}
      <br></br>
      <br></br>
      <Skills></Skills>
      <br></br>
      <br></br>
      
      {/* <Certificate></Certificate> */}
      <br></br>
      <br></br>
      <Work></Work>
      <br></br>
      <br></br>
      <Project></Project>
      <br></br>
      <br></br>
      <Contact></Contact>
      <ToastContainer limit={5} />
      {/* <ContactForm></ContactForm> */}
<Footer></Footer>
<div className='scrollContainer'>
          <a className="cntTop" href='#top'>
          <BsFillArrowUpCircleFill className="scrollBtn"/>

          </a>
      </div>
    </div>
  );
}

export default App;
